import { useEffect, useMemo, useState } from 'react';

type PathLike = {
  id?: string;
  name?: string;
  weight: number;
  active?: boolean;
  landers?: Array<{ id: string; name: string; weight: number }>;
  offers?: Array<{ id: string; name: string; weight: number }>;
};

type PathGroupLike = {
  id: string;
  name: string;
  paths: PathLike[];
};

export function useFlowPathGroups(params: {
  flowId?: string;
  defaultPaths: PathLike[];
  pathGroups: PathGroupLike[];
}) {
  const { flowId, defaultPaths, pathGroups } = params;

  const pathsAll = useMemo(() => {
    const fromDefault = defaultPaths.map((p) => ({ ...p, groupId: 'default' }));
    const fromGroups = pathGroups.flatMap((g) => g.paths.map((p) => ({ ...p, groupId: g.id })));
    return [...fromDefault, ...fromGroups];
  }, [defaultPaths, pathGroups]);

  const groupOptions = useMemo(() => {
    const base = [{ id: 'default', name: 'Default paths' }];
    const groups = pathGroups.map((g) => ({ id: g.id, name: g.name }));
    return [...base, ...groups];
  }, [pathGroups]);

  const [selectedGroupId, setSelectedGroupId] = useState<string>('default');

  useEffect(() => {
    setSelectedGroupId('default');
  }, [flowId]);

  useEffect(() => {
    if (groupOptions.some((g) => g.id === selectedGroupId)) return;
    setSelectedGroupId(groupOptions[0]?.id ?? 'default');
  }, [groupOptions, selectedGroupId]);

  return { pathsAll, groupOptions, selectedGroupId, setSelectedGroupId };
}

